import { Navigate, Outlet, useRoutes } from "react-router-dom";
import LandingPageFooter from "../components/LandingPageFooter";
import LandingPageHeader from "../components/LandingPageHeader";
import BreadcrumbNavigation from "../components/BreadcrumbNavigation";
import { ROUTING_NAMES } from "../constants/routingConstant";
import {
  LazyLandingPage,
  PayFeePage,
  LazyAboutUsPage,
  LazyServices,
  LazyFeatures,
  // LazyPricing,
  LazyContactUs,
  LazyBlogPage,
  LazyCareers,
  LazyBecomeAPartner,
  LazyDelhiPage,
  LazyMumbaiPage,
  LazyBangalorePage,
} from "../components/LazyComponents";
import RefundPolicy from "../pages/RefundPolicy";
import GovermentCertified from "../pages/GovermentCertified";
import TermAndConditions from "../pages/TermAndCondition";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Security from "../pages/Security";
import BlogDetail from "../pages/Blog/BlogDetail";
import PayFee from "../pages/PayFee/PayFee";
import HandleJuspayResponse from "../pages/HandleJuspayResponse/HandleJuspayResponse";
import EasebuzzReturn from "../pages/EasebuzzReturn/EasebuzzReturn";

const RootRoutes = () => {
  return useRoutes([
    {
      path: "/",
      element: (
        <>
          <LandingPageHeader />
          <BreadcrumbNavigation />
          <Outlet />
          <LandingPageFooter />
        </>
      ),
      children: [
        {
          path: ROUTING_NAMES.home,
          element: <LazyLandingPage />,
        },
        {
          path: ROUTING_NAMES.payFee,
          element: <PayFee />,
        },
        {
          path: ROUTING_NAMES.handleJuspayResponse,
          element: <HandleJuspayResponse />,
        },
        {
          path: ROUTING_NAMES.easebuzzReturn,
          element: <EasebuzzReturn />,
        },
        {
          path: `${ROUTING_NAMES.easebuzzReturn}/success`,
          element: <EasebuzzReturn />,
        },
        {
          path: `${ROUTING_NAMES.easebuzzReturn}/failure`,
          element: <EasebuzzReturn />,
        },
        {
          path: ROUTING_NAMES.services,
          element: <LazyServices />,
        },
        {
          path: ROUTING_NAMES.features,
          element: <LazyFeatures />,
        },
        // {
        //   path: ROUTING_NAMES.pricing,
        //   element: <LazyPricing />,
        // },
        {
          path: ROUTING_NAMES.aboutUs,
          element: <LazyAboutUsPage />,
        },
        {
          path: ROUTING_NAMES.partners,
          element: <LazyBecomeAPartner />,
        },
        {
          path: ROUTING_NAMES.careers,
          element: <LazyCareers />,
        },
        {
          path: ROUTING_NAMES.contact_us,
          element: <LazyContactUs />,
        },
        {
          path: ROUTING_NAMES.refundPolicy,
          element: <RefundPolicy />,
        },
        {
          path: ROUTING_NAMES.govermentCertified,
          element: <GovermentCertified />,
        },
        {
          path: ROUTING_NAMES.termAndConditions,
          element: <TermAndConditions />,
        },
        {
          path: ROUTING_NAMES.privacyPolicy,
          element: <PrivacyPolicy />,
        },
        {
          path: ROUTING_NAMES.security,
          element: <Security />,
        },
        {
          path: ROUTING_NAMES.blogs,
          element: <LazyBlogPage />,
        },
        {
          path: "blog/:slug",
          element: <BlogDetail />,
        },
        {
          path: "delhi",
          element: <LazyDelhiPage />,
        },
        {
          path: "mumbai",
          element: <LazyMumbaiPage />,
        },
        {
          path: "bangalore",
          element: <LazyBangalorePage />,
        },
      ],
    },
  ]);
};

export default RootRoutes;
